import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

export default function DownloadBrouchure({
    endpoint = ApiEndpoints.contact.broucherPageQueryList,
    title = "Broucher Page Query",
    tableHeader = ["Date",    "Form Type", "Name", "Contact Number",    "Source Url", "Current Url"],
    tbody = ["createdAt",  "form_type", "name", "phoneNumber",   "source_url", "current_url"],
}) {
    const [data, setData] = useState([]);
    useEffect(() => {
      const dataFetch = async () => {
          try {
              const response = await ApiRequest("GET", endpoint);
              const result = response.contacts;
              setData(result);
          } catch (error) {
              console.log(error);
          }
      };

        dataFetch();
    }, [endpoint]);

    const pagename = {
      name: title,
      user: 'Admin',
      innerpage: title
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>
    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}



